import script from "./RewardsSummaryQuery.vue?vue&type=script&lang=js"
export * from "./RewardsSummaryQuery.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__